import {searchList} from "./array";
import {isString} from "lodash";

/**
 *
 * @param list {*[]}
 * @param keyword {string}
 * @returns {*[]}
 */
export const filterList = (list, keyword) => searchList(list, keyword, '_helper')

export const collectIds = collection => collection.map(({id}) => id).filter(id => isString(id))